import { Box, Button, Stack, Typography } from "@mui/material";
import { useStatusBankingAccountMutation } from "Api/Mutations/Accounts/useStatusBankingAccountMutation";
import { CloseIcon, DoneIcon } from "Components/Shared/Icons";
import { BankAccountStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.BankAccounts.ManualBankAccountVerificationPrompt;

type Props = {
  bankAccountPublicID: string;
  userID: number;
};

export const ManualBankAccountVerificationPrompt = ({
  bankAccountPublicID,
  userID,
}: Props) => {
  const { t } = useResource();
  const { mutate: saveAccountStatus } = useStatusBankingAccountMutation({
    userID,
  });

  const handleConfirm = () => {
    if (window.confirm(t(COMPONENT_RESOURCES.ActivateConfirmationPrompt))) {
      saveAccountStatus({
        bankAccountPublicID,
        status: BankAccountStatus.Active,
      });
    }
  };

  const handleReject = () => {
    if (window.confirm(t(COMPONENT_RESOURCES.RejectConfirmationPrompt))) {
      saveAccountStatus({
        bankAccountPublicID,
        status: BankAccountStatus.Rejected,
      });
    }
  };

  return (
    <Stack gap={3} my={3}>
      <Typography textAlign="center" fontSize="1.1rem">
        {t(COMPONENT_RESOURCES.ManualVerificationNecessary)}
      </Typography>
      <Box
        display="flex"
        gap={2}
        width="80%"
        justifyContent="center"
        alignSelf="center"
      >
        <Button
          fullWidth
          size="medium"
          color="success"
          variant="contained"
          startIcon={<DoneIcon height="1rem" width="1rem" />}
          onClick={handleConfirm}
        >
          {t(COMPONENT_RESOURCES.Activate)}
        </Button>
        <Button
          fullWidth
          size="medium"
          color="error"
          variant="contained"
          startIcon={<CloseIcon height="1rem" width="1rem" />}
          onClick={handleReject}
        >
          {t(COMPONENT_RESOURCES.Reject)}
        </Button>
      </Box>
    </Stack>
  );
};
